import { Signal } from '@angular/core';

import { TellentNavigationGroup, TellentNavigationViewModel } from '@core/tellent-types';

export abstract class TellentNavigationController {
  public abstract minimized: Signal<boolean>;
  public abstract viewModel: Signal<TellentNavigationViewModel>;

  public abstract handleNavigationLinkClick(url: string): void;
  public abstract setUserSelectedGroup(group: TellentNavigationGroup): void;
  public abstract clearUserSelectedGroup(): void;
}
